import React from 'react'

const states = [
  'AL',
  'AK',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WI',
  'WV',
  'WY',
]
states.sort()

const StateSelector = ({ value, onChange, id, ...rest }) => {
  return (
    <select id={id} value={value} onChange={onChange} className="form-control" {...rest}>
      <option value=""></option>
      {states.map((state, i) => (
        <option key={i} value={state}>
          {state}
        </option>
      ))}
    </select>
  )
}

export default StateSelector
